
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as about6Vgf2e_45ZWwa_45DDxcsm2LFgKBFkBxwt_su_XdCkSeybIMeta } from "/opt/buildhome/repo/pages/about.vue?macro=true";
import { default as indexQLbd_45_VEGEymTy61om4OM78JfxLHuFgCIu_qxD7KdRoMeta } from "/opt/buildhome/repo/pages/index.vue?macro=true";
import { default as loginKMdcZdjxVWBby7qzc8iax1m1i6js8gN3t8PvZM_RwR8Meta } from "/opt/buildhome/repo/pages/login.vue?macro=true";
import { default as termsM_RN9_459iuNVtH23UOLrjvoINYU4b2nnq0grhd_RmiYYMeta } from "/opt/buildhome/repo/pages/terms.vue?macro=true";
import { default as indexsSHEynImpmVJQBsgEWtpFbTIimvAlNbjHy0W37sieOIMeta } from "/opt/buildhome/repo/pages/account/index.vue?macro=true";
import { default as subscriptionsef8m95Q1E_45J79LcAd_45RAY3qfixo1CSpfsxjqNkfKKfoMeta } from "/opt/buildhome/repo/pages/account/subscriptions.vue?macro=true";
import { default as accountr_45Zzh2gkubalyv5GEL5snf9O8BjMTTSWW8Qi_45630ctMMeta } from "/opt/buildhome/repo/pages/account.vue?macro=true";
import { default as contactxgbCBTXU_45d0XJYTpbmfD1UGZKjSEtzA80xt962KkT7QMeta } from "/opt/buildhome/repo/pages/contact.vue?macro=true";
import { default as cookieshtP6F02lBALtGxPTRKVnvGvawtAS2_45RpkQD0HOTY6WIMeta } from "/opt/buildhome/repo/pages/cookies.vue?macro=true";
import { default as privacyArxgULVZ2Zifu3wQfKQ0WvqaXaBxDlpI2F7eal9OET8Meta } from "/opt/buildhome/repo/pages/privacy.vue?macro=true";
import { default as newslettervbstlW1aXPob_kb_S6_45vN2SKlT_45S3Ae_D5tttUKfvLsMeta } from "/opt/buildhome/repo/pages/newsletter.vue?macro=true";
import { default as indexjYLHr6NXjpvFf_gXujeNDoOTZnxcSaS9oAuKnKWOqgoMeta } from "/opt/buildhome/repo/pages/search/index.vue?macro=true";
import { default as set_45passwordRVNlywD2VBOO_UxDrrgnf3Wgy4cZX6iXOZt5eJxN68sMeta } from "/opt/buildhome/repo/pages/set-password.vue?macro=true";
import { default as _91slug_93fh6R2_WipaUFFonZ3F3nsQt7Rvco_45O2LawOIuvv8YWIMeta } from "/opt/buildhome/repo/pages/article/[slug].vue?macro=true";
import { default as reset_45password7TTpC6bsKAnTRrn0c2lyZltThWIyP9fDCYnH6eGiD0oMeta } from "/opt/buildhome/repo/pages/reset-password.vue?macro=true";
import { default as request_45a_45trialDeLukGFzhHgaPO5qOyovUD70BtSO_DicFtWK9qSJ4MsMeta } from "/opt/buildhome/repo/pages/request-a-trial.vue?macro=true";
import { default as _91tag_93c3W5S25xO9xDjjmhk9O5wFySWk_liyjnGCqpBKQ1qPQMeta } from "/opt/buildhome/repo/pages/search/tag/[tag].vue?macro=true";
import { default as data_45visualisationVzbGlwmJzTL9sKVZDnUAqTXft8CD4JIT93abNeClBNYMeta } from "/opt/buildhome/repo/pages/data-visualisation.vue?macro=true";
import { default as _91_91category_93_93emQPLzafKE3zBzu7szsCqRjV9ODP0RT9iiIToL4PVgIMeta } from "/opt/buildhome/repo/pages/video/[[category]].vue?macro=true";
import { default as _91slug_93nbn6qBC6_457w6q8lTvekc4e9OZlqaxe_45qev1dz0_457zFAMeta } from "/opt/buildhome/repo/pages/video/watch/[slug].vue?macro=true";
import { default as magazine5DgJlQ9BQElVDXn0buL_452t3PLOSE6BvO8F0zmtQU_45GYMeta } from "/opt/buildhome/repo/pages/publications/magazine.vue?macro=true";
import { default as guestq3Xii_45_xxuanJ7MrtjaobxxyUepc35be8V_ek8JGg_45UMeta } from "/opt/buildhome/repo/pages/viewer/pdf/[[id]]/guest.vue?macro=true";
import { default as index2nbP1Y0mS560Wng1E27Ag_45h5_iMmWNE7cuCqmgLIpWkMeta } from "/opt/buildhome/repo/pages/viewer/pdf/[[id]]/index.vue?macro=true";
import { default as _91category_93RmXM2hSuNvyn8u_45sCh0uFy2l3NCOGxm1e5w2c4yDh98Meta } from "/opt/buildhome/repo/pages/search/category/[category].vue?macro=true";
import { default as indexSadgllP5oB3CViz8_45L_w6un_45y67lgO5JprwRnOm7mKoMeta } from "/opt/buildhome/repo/pages/publications/briefings/index.vue?macro=true";
import { default as _91id_93r_453k0scHxghZn9u9aa5Rpuuc8pDvaXwo1e5Iu5IWXN8Meta } from "/opt/buildhome/repo/pages/publications/presentations/[id].vue?macro=true";
import { default as index7O0WgbG7Fvg2MxPRB9WfkaqcjS1EeYJl4PGwTHqMGu0Meta } from "/opt/buildhome/repo/pages/publications/presentations/index.vue?macro=true";
import { default as _91id_93rrMsDHEDTm9JuADTnWwCsQa_45g4XENhtnzAfr2u2BquAMeta } from "/opt/buildhome/repo/pages/publications/special-issues/[id].vue?macro=true";
import { default as indextiCuN_C061W3b0a9jgmD0K3HWiTHrIvCO33LZNQABDEMeta } from "/opt/buildhome/repo/pages/publications/special-issues/index.vue?macro=true";
import { default as _91_91subcategory_93_93q76FLzoEiMALIsKdb9XrmWFRSOAbnHKwwI65mkSjtm0Meta } from "/opt/buildhome/repo/pages/category/[category]/[[subcategory]].vue?macro=true";
import { default as _91slug_93RKqMGo8RpVUtQCzzpRk9Ors5jvT_45q_bkOM6k_CvLoXgMeta } from "/opt/buildhome/repo/pages/publications/briefings/[category]/[slug].vue?macro=true";
import { default as component_45stub762Hq4tyowd1_45uW_45LbpX4FuJGp4hsK1aP5PZYLTJqWoMeta } from "/opt/buildhome/repo/node_modules/.pnpm/nuxt@3.16.2_@netlify+blobs@8.2.0_@parcel+watcher@2.5.1_@types+node@24.3.0_db0@0.3.2_esl_280ec7ac1d31aea7e256dde11e08acab/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stub762Hq4tyowd1_45uW_45LbpX4FuJGp4hsK1aP5PZYLTJqWo } from "/opt/buildhome/repo/node_modules/.pnpm/nuxt@3.16.2_@netlify+blobs@8.2.0_@parcel+watcher@2.5.1_@types+node@24.3.0_db0@0.3.2_esl_280ec7ac1d31aea7e256dde11e08acab/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "about",
    path: "/about",
    component: () => import("/opt/buildhome/repo/pages/about.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/opt/buildhome/repo/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    component: () => import("/opt/buildhome/repo/pages/login.vue")
  },
  {
    name: "terms",
    path: "/terms",
    component: () => import("/opt/buildhome/repo/pages/terms.vue")
  },
  {
    name: accountr_45Zzh2gkubalyv5GEL5snf9O8BjMTTSWW8Qi_45630ctMMeta?.name,
    path: "/account",
    component: () => import("/opt/buildhome/repo/pages/account.vue"),
    children: [
  {
    name: "account",
    path: "",
    component: () => import("/opt/buildhome/repo/pages/account/index.vue")
  },
  {
    name: "account-subscriptions",
    path: "subscriptions",
    component: () => import("/opt/buildhome/repo/pages/account/subscriptions.vue")
  }
]
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/opt/buildhome/repo/pages/contact.vue")
  },
  {
    name: "cookies",
    path: "/cookies",
    component: () => import("/opt/buildhome/repo/pages/cookies.vue")
  },
  {
    name: "privacy",
    path: "/privacy",
    component: () => import("/opt/buildhome/repo/pages/privacy.vue")
  },
  {
    name: "newsletter",
    path: "/newsletter",
    component: () => import("/opt/buildhome/repo/pages/newsletter.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/opt/buildhome/repo/pages/search/index.vue")
  },
  {
    name: "set-password",
    path: "/set-password",
    component: () => import("/opt/buildhome/repo/pages/set-password.vue")
  },
  {
    name: "article-slug",
    path: "/article/:slug()",
    component: () => import("/opt/buildhome/repo/pages/article/[slug].vue")
  },
  {
    name: "reset-password",
    path: "/reset-password",
    component: () => import("/opt/buildhome/repo/pages/reset-password.vue")
  },
  {
    name: "request-a-trial",
    path: "/request-a-trial",
    component: () => import("/opt/buildhome/repo/pages/request-a-trial.vue")
  },
  {
    name: "search-tag-tag",
    path: "/search/tag/:tag()",
    component: () => import("/opt/buildhome/repo/pages/search/tag/[tag].vue")
  },
  {
    name: "data-visualisation",
    path: "/data-visualisation",
    component: () => import("/opt/buildhome/repo/pages/data-visualisation.vue")
  },
  {
    name: "video-category",
    path: "/video/:category?",
    component: () => import("/opt/buildhome/repo/pages/video/[[category]].vue")
  },
  {
    name: "video-watch-slug",
    path: "/video/watch/:slug()",
    component: () => import("/opt/buildhome/repo/pages/video/watch/[slug].vue")
  },
  {
    name: "publications-magazine",
    path: "/publications/magazine",
    component: () => import("/opt/buildhome/repo/pages/publications/magazine.vue")
  },
  {
    name: "viewer-pdf-id-guest",
    path: "/viewer/pdf/:id?/guest",
    meta: guestq3Xii_45_xxuanJ7MrtjaobxxyUepc35be8V_ek8JGg_45UMeta || {},
    component: () => import("/opt/buildhome/repo/pages/viewer/pdf/[[id]]/guest.vue")
  },
  {
    name: "viewer-pdf-id",
    path: "/viewer/pdf/:id?",
    meta: index2nbP1Y0mS560Wng1E27Ag_45h5_iMmWNE7cuCqmgLIpWkMeta || {},
    component: () => import("/opt/buildhome/repo/pages/viewer/pdf/[[id]]/index.vue")
  },
  {
    name: "search-category-category",
    path: "/search/category/:category()",
    component: () => import("/opt/buildhome/repo/pages/search/category/[category].vue")
  },
  {
    name: "publications-briefings",
    path: "/publications/briefings",
    component: () => import("/opt/buildhome/repo/pages/publications/briefings/index.vue")
  },
  {
    name: "publications-presentations-id",
    path: "/publications/presentations/:id()",
    component: () => import("/opt/buildhome/repo/pages/publications/presentations/[id].vue")
  },
  {
    name: "publications-presentations",
    path: "/publications/presentations",
    component: () => import("/opt/buildhome/repo/pages/publications/presentations/index.vue")
  },
  {
    name: "publications-special-issues-id",
    path: "/publications/special-issues/:id()",
    component: () => import("/opt/buildhome/repo/pages/publications/special-issues/[id].vue")
  },
  {
    name: "publications-special-issues",
    path: "/publications/special-issues",
    component: () => import("/opt/buildhome/repo/pages/publications/special-issues/index.vue")
  },
  {
    name: "category-category-subcategory",
    path: "/category/:category()/:subcategory?",
    component: () => import("/opt/buildhome/repo/pages/category/[category]/[[subcategory]].vue")
  },
  {
    name: "publications-briefings-category-slug",
    path: "/publications/briefings/:category()/:slug()",
    component: () => import("/opt/buildhome/repo/pages/publications/briefings/[category]/[slug].vue")
  },
  {
    name: component_45stub762Hq4tyowd1_45uW_45LbpX4FuJGp4hsK1aP5PZYLTJqWoMeta?.name,
    path: "/downloads/:pathMatch(.*)",
    component: component_45stub762Hq4tyowd1_45uW_45LbpX4FuJGp4hsK1aP5PZYLTJqWo
  }
]